import React from 'react'
import PropTypes from 'prop-types'
import { Columns } from 'src/components/layout'
import { Icon } from 'src/components/icons'
import { LocalizedText } from 'src/components/intl'
import Checkbox from '../Checkbox'

const LocalizedCheckbox = ({ icon, color, i18n, ...props }) => (
  <Checkbox
    label={
      <Columns layout="auto 1">
        <Icon fixedWidth icon={icon} color={color} size="lg" />
        <LocalizedText id={i18n} />
      </Columns>
    }
    {...props}
  />
)

LocalizedCheckbox.propTypes = {
  name: PropTypes.node,
  icon: PropTypes.elementType,
  color: PropTypes.string,
  i18n: PropTypes.string,
}

export default LocalizedCheckbox
